import React, {useContext, useEffect} from 'react';
import './BuyFactorKolAndJoz.scss';
import DynaInput from "../../DynaView/DynaInput";
import DynaDatePicker from "../../DynaView/DynaDatePicker";
import DynaSelectBox from "../../DynaView/DynaSelectBox";
import DynaButton from "../../DynaView/DynaButton";
import DynaRLookUpOpener from "../../DynaView/DynaRLookUpOpener";
import UtilsFunctions from "../../../../utils/UtilsFunctions";
import {toast} from "react-toastify";
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {SetPrintDataContext} from "../../../../Pages";
import {useNavigate} from "react-router-dom";

const BuyFactorKol = ({setSendData, sendData, initialData, onSubmitForm, totalPrice}) => {

  const setPrint = useContext(SetPrintDataContext);
  let navigate = useNavigate();
  const paymentType = [
    {label: "نقدی", value: "fund"},
    {label: "واریز به حساب بانکی", value: "bank"},
    {label: "حساب دفتری", value: "seller"},
    {label: "نقدی و حساب بانکی", value: "fundAndBank"},
  ]

  useEffect(() => {
    setSendData({...sendData, fundPrice: totalPrice.sumFactor})
  }, [totalPrice.sumFactor]);

  const fundAndBankHandler = (data) => {
    const newFundPrice = +totalPrice.sumFactor - +data.bankPrice
    if (newFundPrice >= 0) {
      setSendData({...sendData, fundPrice: newFundPrice, bankPrice: +data.bankPrice})
    } else {
      toast.error("مجموع نقد و بانک باید برابر با مجموع فاکتور باشد")
    }
  }

  const onlyPrintBarcode = async () => {
    let codeArray = [];
    sendData.tableData.forEach((v) => {
      if (v?.number === "1") {
        codeArray.push(v?.productId)
      } else {
        let i = 0
        while (i < +v?.number) {
          codeArray.push(v?.productId)
          i = i + 1
        }
      }
    })

    const CodesArrayFormData = new FormData();
    CodesArrayFormData.append("id", `[${codeArray}]`);
    CodesArrayFormData.append("type", "id");
    CodesArrayFormData.append("request", "barcodeData");

    const responsePrint = await _axios.post(prefixUrl() + "/barcode/", CodesArrayFormData)
    if (responsePrint.data.status) {
      responsePrint.data.type = "BarcodeDataPrint";
      const sendData = {
        type: responsePrint.data.type, data: responsePrint.data,
      };
      setPrint(sendData);
      navigate("/factorprint");
    } else {
      toast.error(responsePrint?.data?.message)
    }
  }

  try {
    return (
      <>
        {Object.keys(initialData).length > 0 &&
          <div className="buy-fac-kol">
            <DynaInput label={"شماره فاکتور"}
                       name={"factorNumber"}
                       className={"solid-dyna-input"}
                       placeholder={"شماره فاکتور"}
                       value={sendData?.factorNumber}
                       type={"text"}
                       setDataFromComponent={(data) => {
                         setSendData({...sendData, ...data})
                       }}
            />

            <DynaDatePicker label={"تاریخ"}
                            name={"date"}
                            className={"solid-dyna-input"}
                            value={sendData?.date}
                            setDataFromComponent={(data) => {
                              setSendData({...sendData, ...data})
                            }}
            />

            <DynaSelectBox options={paymentType}
                           hasFilter={false}
                           label={"نوع پرداخت"}
                           className={"solid-dyna-input"}
                           value={sendData?.paymentType}
                           onChange={(data) => setSendData({...sendData, paymentType: data.value})}
            />

            {
              sendData?.paymentType === "fund" ?
                <DynaRLookUpOpener requestId={initialData?.fundRLookUpId}
                                   id={initialData?.RLookUpFields?.fundId}
                                   keyName={"fundId"}
                                   caption={sendData?.fundName !== "" ? sendData?.fundName : "انتخاب صندوق"}
                                   classname={"solid-opener"}
                                   sendData={sendData}
                                   setSendData={setSendData}/> :
                sendData?.paymentType === "bank" ?
                  <DynaRLookUpOpener requestId={initialData?.bankRLookUpId}
                                     id={initialData?.RLookUpFields?.bankId}
                                     keyName={"bankId"}
                                     caption={sendData?.bankName !== "" ? sendData?.bankName : "انتخاب بانک"}
                                     classname={"solid-opener"}
                                     sendData={sendData}
                                     setSendData={setSendData}/> :
                  sendData?.paymentType === "seller" ?
                    <DynaRLookUpOpener requestId={initialData?.sellerRLookUpId}
                                       id={initialData?.RLookUpFields?.sellerId}
                                       keyName={"sellerId"}
                                       caption={sendData?.sellerName !== "" ? sendData?.sellerName : "انتخاب فروشنده"}
                                       classname={"solid-opener"}
                                       sendData={sendData}
                                       setSendData={setSendData}/> :
                    sendData?.paymentType === "fundAndBank" ?
                      <div>
                        <DynaRLookUpOpener requestId={initialData?.fundRLookUpId}
                                           id={initialData?.RLookUpFields?.fundId}
                                           keyName={"fundId"}
                                           caption={sendData?.fundName !== "" ? sendData?.fundName : "انتخاب صندوق"}
                                           classname={"solid-opener"}
                                           sendData={sendData}
                                           setSendData={setSendData}/>
                        <DynaRLookUpOpener requestId={initialData?.bankRLookUpId}
                                           id={initialData?.RLookUpFields?.bankId}
                                           keyName={"bankId"}
                                           caption={sendData?.bankName !== "" ? sendData?.bankName : "انتخاب بانک"}
                                           classname={"solid-opener"}
                                           sendData={sendData}
                                           setSendData={setSendData}/>
                      </div> :
                      <>No Type</>
            }

            {sendData?.paymentType === "fundAndBank" &&
              <div className="grid-row">
                <DynaInput label={"نقدی"}
                           name={"fundPrice"}
                           className={"solid-dyna-input"}
                           placeholder={"نقدی"}
                           disabled={true}
                           value={UtilsFunctions.addCommas(+totalPrice.sumFactor - +sendData?.bankPrice)}
                           hasComma={true}
                           type={"text"}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}
                />

                <DynaInput label={"حساب بانکی"}
                           name={"bankPrice"}
                           className={"solid-dyna-input"}
                           placeholder={"حساب بانکی"}
                           value={UtilsFunctions.addCommas(sendData?.bankPrice)}
                           hasComma={true}
                           type={"text"}
                           setDataFromComponent={(data) => {
                             fundAndBankHandler(data)
                           }}
                />
              </div>
            }

            <DynaInput label={"عنوان خدمات"}
                       name={"serviceTitle"}
                       className={"solid-dyna-input"}
                       placeholder={"عنوان خدمات را وارد کنید"}
                       value={sendData?.serviceTitle}
                       type={"text"}
                       setDataFromComponent={(data) => {
                         setSendData({...sendData, ...data})
                       }}
            />

            <DynaInput label={"مبلغ خدمات"}
                       name={"servicePrice"}
                       className={"solid-dyna-input"}
                       placeholder={"مبلغ خدمات را وارد کنید"}
                       value={UtilsFunctions.addCommas(sendData?.servicePrice)}
                       hasComma={true}
                       type={"text"}
                       setDataFromComponent={(data) => {
                         setSendData({...sendData, ...data})
                       }}
            />

            <div className="grid-row">
              <DynaInput label={"مالیات"}
                         name={"tax"}
                         className={"solid-dyna-input"}
                         placeholder={"درصد مالیات"}
                         value={sendData?.tax}
                         type={"number"}
                         setDataFromComponent={(data) => {
                           if (+data.tax <= 100) {
                             setSendData({...sendData, ...data})
                           }
                         }}
              />

              <DynaInput label={"تخفیف"}
                         name={"totalDiscount"}
                         className={"solid-dyna-input"}
                         placeholder={"مبلغ تخفیف"}
                         value={UtilsFunctions.addCommas(sendData?.totalDiscount)}
                         hasComma={true}
                         type={"text"}
                         setDataFromComponent={(data) => {
                           if (+data.totalDiscount < +totalPrice.sumFactor) {
                             setSendData({...sendData, ...data})
                           } else {
                             toast.error("تخفیف باید از جمع فاکتور کمتر باشد")
                           }
                         }}
              />
            </div>

            <div className="grid-row" style={{paddingTop: '1rem'}}>
              <DynaButton className={"simple-but"}
                          type={"button"}
                          onClick={() => onSubmitForm("noPrint")}>ثبت</DynaButton>

              <DynaButton className={"simple-but-no-bac"}
                          type={"button"}
                          onClick={() => onSubmitForm("Print")}>ثبت و پرینت</DynaButton>

              <div style={{gridColumn: "1/-1"}}>
                <DynaButton className={"simple-but-no-bac w-100"}
                            type={"button"}
                            onClick={onlyPrintBarcode}>پرینت بارکد</DynaButton>
              </div>
            </div>

          </div>
        }
      </>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default React.memo(BuyFactorKol);